import React, { useContext, useState, useRef } from "react";
import { none } from "fp-ts/lib/Option";

import UIContext from "../Store/ui-context";
import Modal from "../../utils/Modal/Modal";
import ExportPDFSummary from "../ExportPDFSummary/ExportPDFSummary";
import ErrorDialog from "../UI/ErrorDialog/ErrorDialog";
import { CalculatorResultsPage } from "../CalculatorResultsPage/CalculatorResultsPage";
import { ResultsDisplayToggle } from "../ResultsDisplayToggle/ResultsDisplayToggle";
import { DatePresetsContext } from "../Store/DatePresetsContext";
import { CalculatorResultsContext } from "../Store/CalculatorResultsContext";

import {
  UserInterfaceHints,
  UserInterfaceHintsContext,
} from "../Store/UserInterfaceHintsContext";
import { isSome } from "fp-ts/lib/Option";

const PDF_EXPORT_ENABLED = true;

function CalculatorResults() {
  const datePresetsStore = useContext(DatePresetsContext);
  const uiHint = useContext(UserInterfaceHintsContext);
  const uiContext = useContext(UIContext);
  const resultsStore = useContext(CalculatorResultsContext);
  const exportBtn = useRef<HTMLButtonElement>(null);

  const additionalGainFootnote =
    uiHint.hasHint(UserInterfaceHints.RESULTS_CHART_VIEW) &&
    uiHint.hasHint(UserInterfaceHints.ADDITIONAL_GAIN_SHOWN);

  const [resultsView, setResultsView] = useState("chart");
  const switchView = (view: string) => {
    setResultsView(view);
  };
  const toggleExportPDFSummary = uiContext.showModal;
  const hasError = isSome(resultsStore.pdfExportError);
  const hideModalHandler = () => {
    uiContext.setShowModal(false);
  };
  const focusBtnHandler = () => {
    exportBtn.current && exportBtn.current.focus();
  };
  const onKeyUpHandler = (event: React.KeyboardEvent) => {
    return event.key === 'Escape' && hideModalHandler();
  };
  const onExportPDF = () => {
    resultsStore.setPdfUrl(none);
    resultsStore.setPdfExportError(none);
    resultsStore.setExportingPdf(false);
    resultsStore.setExportingPdfCancelled(false);
    uiContext.setShowModal(true);
    // analyticsToolCTAEvent('', 'Export PDF');
  };

  // useEffect(() => {
  //   if (uiContext.calculationCancelled) {
  //     cancelTokenSource.cancel();
  //     uiContext.setUIState(uiStore.uiState.withCalculationCancelled(false));
  //   }
  // }, [uiStore.calculationCancelled]);

  return (
    <>
      <div id="rila-calculator-tool-results" className="row">
        <ResultsDisplayToggle
          viewChanged={switchView}
          view={resultsView}
        ></ResultsDisplayToggle>
        <DatePresetsContext.Provider value={datePresetsStore}>
          <CalculatorResultsPage resultsView={resultsView} />
        </DatePresetsContext.Provider>
        {additionalGainFootnote ? (
          <p className="footnote ml-2">
            * Additional growth above the index return.
          </p>
        ) : null}
      </div>
      {PDF_EXPORT_ENABLED ? (
        <div className="calculator-tool-result-actions">
          <button
            type="button"
            onClick={onExportPDF}
            className="btn btn--primary"
            ref={exportBtn}
          >
            Export PDF
          </button>
        </div>
      ) : null}
      {toggleExportPDFSummary && (
        <Modal>
          <>
            {hasError && (
              <ErrorDialog onClickHideModalHandler={hideModalHandler} />
            )}
            {!hasError && (
              <ExportPDFSummary
                onClickHideModalHandler={hideModalHandler}
                onFocusExportBtnHandler={focusBtnHandler}
                onKeyUpBtnHandler={onKeyUpHandler}
              />
            )}
          </>
        </Modal>
      )}
    </>
  );
}

export default CalculatorResults;
